import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import CartDrawer from "./CartDrawer.jsx"
import CartCount from "./CartCount.jsx"
import { setCart, setGift } from '../store/cartSlice'
// import { updateUpsells } from '../../utils/Cart'

document.addEventListener('DOMContentLoaded', () => {
  store.dispatch(setCart(window.initialCart))
  
  const cartDrawerWrapper = document.querySelector('[data-cart-drawer]')
  const cartProps = JSON.parse(cartDrawerWrapper.getAttribute('props'))
  const cartDrawerRoot = createRoot(cartDrawerWrapper)
  cartDrawerRoot.render(
    <Provider store={store}>
      <CartDrawer data={cartProps} />
    </Provider>)

  const cartCounts = document.querySelectorAll('[data-cart-count]')
  cartCounts.forEach(cartCount => {
    const cartCountRoot = createRoot(cartCount)
    cartCountRoot.render(
      <Provider store={store}>
        <CartCount data={cartProps} />
      </Provider>)
  })
  
  // updateUpsells()
  store.dispatch(setGift(window.initialCart.items.filter(item => item.variant_id == cartProps.gift_variant_id).length > 0))
})